import { useMemo } from 'react';
import type { VoidFunctionComponent } from 'react';

import { useFetchCweList } from '../../../hooks/api/weaknesses/useFetchCweList';
import { selectOptionFactory } from '../../../utils';
import FilterCardMultiSelect from '../../generic/Filter/FilterCardMultiSelect';
import type { AnyFilter } from '../../../../shared/organizationPackages/filters';

type Props = { cwes: string[]; setFilters: (...args: AnyFilter[]) => void };

/**
 * Renders an autocomplete CWEs dropdown
 */
const VulnCWE: VoidFunctionComponent<Props> = ({
  cwes,
  setFilters,
}) => {
  const { data: cweList, isLoading } = useFetchCweList();
  const options = useMemo(
    () => (cweList ?? []).map((cwe) => selectOptionFactory(`CWE-${cwe.id}`)),
    [cweList],
  );

  return (
    <FilterCardMultiSelect
      isDisabled={isLoading}
      label="CWE"
      options={options}
      placeholder="Select one or more..."
      values={cwes.map((cwe) => selectOptionFactory(cwe))}
      onChange={(selectedOptions) => {
        if (selectedOptions.length) {
          setFilters({
            cwes: selectedOptions.map((option) => option.value),
          });
        } else {
          setFilters({
            cwes: [],
          });
        }
      }}
    />
  );
};

export default VulnCWE;
